import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import SummarySectionTitle from './Component/SummarySectionTitle';
import SummaryFeaturePrinting from './Component/SummaryFeaturePrinting';
import { currencyFormatter } from '../../utils/currencyFormatter';
import { PriceUtility } from '../../utilities/PriceUtility';

const SummarySectionsListPrinting = ({ login }) => {
    const {
        rooms, categories, totalPrice, vatPercentage,
    } = useSelector(state => state.configurator);

    return (
      <div className="summary-sections-list-printing">
        <div className="summary-sections-list-header">
          <div className="title">Su configuración</div>
        </div>

        <div className="description">A continuación se muestra un resumen de las opciones que ha seleccionado:</div>
        <div className="container-sections">
          {rooms !== undefined && rooms.map((room, index) => (
            <>
              <div className="summary-feature-container">
                <SummarySectionTitle title={room.name} />
                {
                    room.categories.map((roomCategory, index2) => {
                        const category = categories.find(cat => cat.id === roomCategory.id);
                        if (category.features !== undefined && category.features.length > 0) {
                            const selectedFeature = category.features.find(
                                feature => feature.id === category.selected_feature,
                            );
                            if (selectedFeature !== undefined) {
                                return (
                                  <div className="container-title-feature">
                                    <SummaryFeaturePrinting
                                      categoryName={category.name}
                                      feature={selectedFeature}
                                      disabled={category.disabled}
                                    />
                                  </div>
                                );
                            }
                        }
                        return null;
                    })
                }
              </div>
            </>
                ))}
        </div>
        {login ? (
          <div className="total-price-summary-container">
            <div className="divider" />
            <div className="total-price-exc-vat-row">
              <div className="title">PRECIO TOTAL (SIN IVA)</div>
              <div className="value">{currencyFormatter.format(totalPrice)}</div>
            </div>
            <div className="vat-row">
              <div className="title">DESGLOSE IVA</div>
              <div className="value">
                {currencyFormatter.format(PriceUtility.calculateVatValue(totalPrice, vatPercentage))}
              </div>
            </div>

            <div className="total-price-inc-vat-row">
              <div className="title">PRECIO TOTAL</div>
              <div className="value">
                {currencyFormatter.format(PriceUtility.calculateTotalPriceIncVat(totalPrice, vatPercentage))}
              </div>
            </div>

          </div>
            ) : null}
      </div>
    );
};

SummarySectionsListPrinting.propTypes = {
    login: PropTypes.bool,
};

SummarySectionsListPrinting.defaultProps = {
    login: false,
};

export default SummarySectionsListPrinting;
